import axios from 'axios';
import AuthService from './AuthService';


const API_URL = process.env.REACT_APP_API_URL;

axios.interceptors.request.use((config) =>
  AuthService.prepareAuthenticatedRequest(config)
);
 


const LeadService = {
  getAllLeads: async (userId) => {
    try {
      const response = await axios.get(`${API_URL}/Lead/GetAllLeads/${userId}`);
      return response.data.$values;
      
    } catch (error) { 
      console.error('Error fetching leads:', error);
      throw error;
    }
  },

  getFilteredLeadsByClientId: async (clientId, fromDate, toDate, pageNumber, pageSize, searchTerm = '') => {
    try {
      const response = await axios.get(
        `${API_URL}/Lead/GetFilteredLeadsByClientId/${clientId}/${fromDate}/${toDate}/${pageNumber}/${pageSize}`,
        { params: { searchTerm: searchTerm || undefined } }
      );
      const envelope = response.data?.value ?? response.data;
      const raw = envelope?.data ?? envelope?.Data ?? [];
      return {
        data: Array.isArray(raw) ? raw : (raw?.$values ?? []),
        recordsTotal: envelope?.recordsTotal ?? envelope?.RecordsTotal ?? 0,
        recordsFiltered: envelope?.recordsFiltered ?? envelope?.RecordsFiltered ?? 0,
        pageNumber: envelope?.pageNumber ?? pageNumber,
        pageSize: envelope?.pageSize ?? pageSize,
      };
    } catch (error) {
      console.error('Error fetching filtered leads:', error);
      throw error;
    }
  },

  getLeadById: async (id) => { 
    try {
      const response = await axios.get(`${API_URL}/Lead/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error fetching lead with ID ${id}:`, error);
      throw error;
    } 
  },

  getLeadId:async()=>{
  const response=await axios.get(`${API_URL}/Lead`);
  return response.data.id;
  },

  createLead: async (leadData) => {
    try {
      const response = await axios.post(`${API_URL}/Lead`, leadData);
      return response.data;
    } catch (error) {
      console.error('Error creating Lead:', error);
      throw error;
    }
  },

  updateLead: async (id, leadData) => {
    try {
      const response = await axios.put(`${API_URL}/Lead/${id}`, leadData);
      return response.data;
    } catch (error) {
      console.error(`Error updating lead with ID ${id}:`, error);
      throw error;
    }
  }, 

  deleteLead: async (id) => {
    try {
      const response = await axios.delete(`${API_URL}/Lead/${id}`);
      return response.data;
    } catch (error) {
      console.error(`Error deleting lead with ID ${id}:`, error); 
      throw error;
    }
  },

getLeadsByUserId: async (userId) => {
  try {
    const response = await axios.get(`${API_URL}/Lead/LeadsByUserId/${userId}`);
    return response.data.$values;
  } catch (error) {
    console.error(`Error fetching leads for user with ID ${userId}:`, error);
    throw error;
  }
}, 

searchLeads: async (query) => {
  try {
    const response = await axios.get(`${API_URL}/Lead/Search`, {
      params: { searchTerm: query }  
    });
    console.log(response.data.$values);
    return response.data.$values;  
  } catch (error) {
    console.error('Error searching leads:', error);
    throw error;
  }
},

AssignedLeadsToEmployee: async (userId, leadIds) => {
  try {
    const requestBody = {
      leadIds,
      leadAssignedDtos: [ 
        {
          leadStatusId: 1,
          propertyTypeId: 2,
          conversationComment: 'Assigned to employee',
          leadAssignedDate: new Date().toISOString(),
          followUpDate: new Date().toISOString(),
          userId,
        },
      ],
    };
    const response = await axios.post(`${API_URL}/LeadAssigned/AssignedLeadsToEmployee/${userId}/${leadIds}`, requestBody);
    return response.data;
  } catch (error) {
    console.error('Error assigning lead:', error);
    throw error;
  }
},


async RecordStatusChange(leadAssignedId, newStatus, followUpDate, nextUpdate, newConversationComment) {
  try {
    const response = await axios.put(
      `${API_URL}/LeadHistory/RecordStatusChange/${leadAssignedId}/${newStatus}/${followUpDate}/${nextUpdate}/${encodeURIComponent(newConversationComment)}`
    );
    return response.data;
  } catch (error) {
    console.error('Error recording status change:', error);
    throw error;
  }
},

createLeadHistory: async (historyData) => {
  try {
    const response = await axios.post(`${API_URL}/LeadHistory`, historyData);
    return response.data;
  } catch (error) {
    console.error('Error creating lead history:', error);
    throw error;
  }
},

getLeadHistoryByLeadId: async (leadId) => {
  try {
    const response = await axios.get(`${API_URL}/LeadHistory/GetLeadHistoryByLeadIdAsync/${leadId}`);
    const data = response.data;
    return Array.isArray(data) ? data : (data?.$values || []);
  } catch (error) {
    console.error('Error fetching lead history:', error);
    throw error;
  }
},

getAllLeadStatus: async () => {
  try {
    const response = await axios.get(`${API_URL}/LeadStatus/GetAllLeadStatus`);
    return response.data.$values;
  } catch (error) {
    console.error(`Error fetching leads status list`, error);
    throw error;
  }
}, 


};


export default LeadService;
